import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ClientLookupOption } from '../../domain/models/client-lookup-option.model';
import { IClientLookupRepository } from '../../domain/repositories/client-lookup.repository';
import { ClientLookupRemoteDatasource } from '../datasources/remote/client-lookup.remote-datasource';
import { ClientLookupMapper } from '../mappers/client-lookup.mapper';

@Injectable()
export class ClientLookupRepositoryImpl implements IClientLookupRepository {
  private readonly datasource = inject(ClientLookupRemoteDatasource);
  private readonly mapper = inject(ClientLookupMapper);

  public search(term: string): Observable<readonly ClientLookupOption[]> {
    return this.datasource.search(term).pipe(
      map((dto) => this.mapper.toOptions(dto)),
    );
  }

  // A blank term makes the backend (`ProVetProvider.SearchClientsAsync`) return the full roster;
  // 500 is assumed to comfortably cover this app's realistic clinic sizes, mirroring the same
  // "fetch everything" size assumption used elsewhere in this codebase for similar pickers.
  public list(): Observable<readonly ClientLookupOption[]> {
    return this.datasource.search('', 1, 500).pipe(
      map((dto) => this.mapper.toOptions(dto)),
    );
  }
}
